import styled from 'styled-components';

export const Footer = styled.footer`
  padding: 3px;
  text-align: center;
  background-color: #eee;
`;
